import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import _ from "lodash";
import { checkKnownDateOrString } from "../";

export function TableRowDetails({ data }) {
  return Object.keys(data).map((oneKey, i) => {
    return (
      <Grid container key={i}>
        <Grid item xs={12} sm={5}>
          <Typography variant="h6">
            {_.startCase(Object.keys(data)[i]) + ":"}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={7}>
          <Typography
            variant="h6"
            sx={{
              mb: 1.5,
              color: "black",
            }}
          >
            {checkKnownDateOrString(oneKey, data[oneKey])}
          </Typography>
        </Grid>
      </Grid>
    );
  });
}
